
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import 'remixicon/fonts/remixicon.css';
import '@fontsource/pacifico/400.css';
import { ThemeService } from './services/themeService';
import { getUdaThemeForHost, accentVars, applyUdaMasterNames } from './pages/home/udaThemes';
import './i18n';

// Initialize theme system
ThemeService.initializeTheme();

// When served from a UDA subdomain (e.g. ruda.dreamstep.in), apply that UDA's
// accent to :root so the ENTIRE portal (header, footer, every page) is themed,
// not just the home landing. DTCP main / unknown host keeps the default accent.
// Done synchronously before render to avoid a flash of the default colour.
const udaHostTheme = getUdaThemeForHost();
if (udaHostTheme) {
  const vars = accentVars(udaHostTheme.accent);
  for (const [key, value] of Object.entries(vars)) {
    document.documentElement.style.setProperty(key, value);
  }
}

/* UDA names come from the one UDA master (ds_uda_lst_t.uda_nm), not from the
   theme file. Read before the first render so no page shows a stale name; a slow
   or failed read gives up after 1.5 s and the page renders with the stand-ins. */
const udaNames = fetch('/apiv1/public/portalweb/udas')
  .then((r) => (r.ok ? r.json() : null))
  .then((j) => applyUdaMasterNames(j?.data || []))
  .catch(() => undefined);

Promise.race([udaNames, new Promise((done) => setTimeout(done, 1500))]).finally(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
